@if (pdfDocument) {
    <div class="flex flex-col justify-center">
        <div
            class="w-full flex md:block md:max-w-[85%] overflow-auto md:mx-auto mt-4 border border-gray-200">
            <canvas
                class="w-full md:w-auto"
                [id]="'pdf-preview-canvas-' + timestamp.toString()"></canvas>
        </div>
        <nav class="grid grid-cols-12 mx-auto">
            <ul class="col-span-4 flex items-center justify-start">
                <button
                    mat-icon-button
                    attr.aria-label="{{
                        'shared.mediaViewer.pdfFirstPageLabel' | translate
                    }}"
                    color="primary"
                    class="small-icon-button"
                    (click)="renderPage(1)"
                    [disabled]="currPage == 1">
                    <mat-icon>keyboard_double_arrow_left</mat-icon>
                </button>
                <button
                    mat-icon-button
                    attr.aria-label="{{
                        'shared.mediaViewer.pdfPreviousPageLabel' | translate
                    }}"
                    color="primary"
                    class="small-icon-button"
                    (click)="renderPage(currPage - 1)"
                    [disabled]="currPage == 1">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
            </ul>
            <div class="col-span-4 flex items-center justify-center">
                <div>{{ currPage }} / {{ pageCount }}</div>
            </div>
            <ul class="col-span-4 flex items-center justify-end">
                <button
                    mat-icon-button
                    attr.aria-label="{{
                        'shared.mediaViewer.pdfNextPageLabel' | translate
                    }}"
                    color="primary"
                    class="small-icon-button"
                    (click)="renderPage(currPage + 1)"
                    [disabled]="currPage == pageCount">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
                <button
                    mat-icon-button
                    attr.aria-label="{{
                        'shared.mediaViewer.pdfLastPageLabel' | translate
                    }}"
                    color="primary"
                    class="small-icon-button"
                    (click)="renderPage(pageCount)"
                    [disabled]="currPage == pageCount">
                    <mat-icon>keyboard_double_arrow_right</mat-icon>
                </button>
            </ul>
        </nav>
    </div>
}
@if (!pdfDocument) {
    <div class="flex items-center justify-center text-center my-4">
        @if (loadFailed()) {
            <div class="flex flex-col items-center gap-2">
                <p>{{ 'shared.pdfViewer.loadError' | translate }}</p>
                <button mat-flat-button color="primary" (click)="retry()">
                    <mat-icon>refresh</mat-icon
                    >{{ 'shared.buttons.retry' | translate }}
                </button>
            </div>
        } @else {
            <apcam-loading-spinner />
        }
    </div>
}
<div class="container-pdf-preview"></div>
